import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule } from '@spartacus/core';
import { MyaccountPaymentDetailsComponent } from './myaccount-payment-details.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MyAccountAccountInfoPaymentDetailsFlexComponent: {
          component: MyaccountPaymentDetailsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
    MyaccountPaymentDetailsComponent,
  ],
})
export class MyaccountPaymentDetailsModule {}
